var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlightIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.502,
    height: 28.15,
    viewBox: "0 0 36.502 28.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Flight_Icon",
    "data-name": "Flight Icon",
    transform: "translate(-29.747 0.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M36.206,9.473a2.9,2.9,0,0,0-3.375-1.759l-1.959-1.18A2.884,2.884,0,0,0,28.42,6.3L21.252,8.871,15.365.657a.575.575,0,0,0-.659-.2L11.5,1.606a.559.559,0,0,0-.34.72l3.306,8.982L7.34,13.87,3.512,9.641a.573.573,0,0,0-.619-.153l-2.14.769a.559.559,0,0,0-.34.72l3.114,8.452a.569.569,0,0,0,.535.37h.007l12.062-.146a.563.563,0,0,0,.188-.034l1.068-.385L20.5,27.686a.569.569,0,0,0,.535.37.578.578,0,0,0,.195-.034l3.21-1.154a.561.561,0,0,0,.372-.575l-.794-9.443,10.486-3.771a2.825,2.825,0,0,0,1.872-2.647,2.787,2.787,0,0,0-.172-.959Zm-23.781-7,2.262-.813,5.456,7.612-4.606,1.655ZM3.234,15.345,1.677,11.121l1.243-.446,3.268,3.609ZM21.379,26.773,17.485,16.208l5.184-1.863.977,11.615ZM34.118,12.024,23.924,15.69l-.183-2.172a.559.559,0,0,0-.26-.427.581.581,0,0,0-.5-.055L16.56,15.343a.568.568,0,0,0-.321.291.556.556,0,0,0-.019.43L17,18.177l-.978.352L4.459,18.67,3.625,16.4,28.807,7.353a1.734,1.734,0,0,1,1.474.142l.545.328-1.671.6.389,1.057,2.526-.908.385.232a.575.575,0,0,0,.487.05,1.737,1.737,0,0,1,2.193,1,1.679,1.679,0,0,1-1.019,2.167Z",
    transform: "translate(29.622 -0.42)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M0,0H1.246V1.246H0Z",
    transform: "translate(54.94 9.565) rotate(-19.993)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M0,0H1.246V1.246H0Z",
    transform: "translate(52.808 10.349) rotate(-19.993)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M0,0H1.246V1.246H0Z",
    transform: "translate(50.677 11.134) rotate(-19.993)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M0,0H1.246V1.246H0Z",
    transform: "translate(48.546 11.919) rotate(-19.993)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M0,0H1.246V1.246H0Z",
    transform: "translate(46.414 12.704) rotate(-19.993)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M0,0H1.246V1.246H0Z",
    transform: "translate(44.282 13.489) rotate(-19.993)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M0,0H1.246V1.246H0Z",
    transform: "translate(42.151 14.273) rotate(-19.993)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M0,0H1.246V1.246H0Z",
    transform: "translate(40.015 15.065) rotate(-19.993)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M0,0H1.246V1.246H0Z",
    transform: "translate(37.882 15.849) rotate(-19.993)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightIconWhite);
export default __webpack_public_path__ + "static/media/FlightIconWhite.81bd6b5cf0074161e867d1ef00c4c89e.svg";
export { ForwardRef as ReactComponent };